import Tabs from '@mui/material/Tabs';
import React from 'react';
interface ProcessTabsProps {
  value: number | false;
  onChange: (event: React.ChangeEvent<{}> | null, newValue: number | false) => void;
  children: React.ReactNode;
  first?: Boolean;
  last?: Boolean;
}

const getGradient = (first?: Boolean, last?: Boolean) => (theme: any) => {
  const dark = theme.palette.info.main;
  const light = theme.palette.primary.light;

  const topColor = first ? dark : light;
  const bottomColor = last ? light : dark;

  return `linear-gradient(${topColor}, ${bottomColor})`;
};

const ProcessPathTabs = ({ first, last, ...props }: ProcessTabsProps) => (
  <Tabs
    {...props}
    onClick={() => props.onChange(null, props.value)}
    TabIndicatorProps={{
      children: <div />
    }}
    scrollButtons
    variant="scrollable"
    allowScrollButtonsMobile
    sx={{
      '& .MuiTabs-flexContainer': {
        paddingBottom: theme => theme.spacing(4),
        alignItems: 'end'
      },
      '& .MuiTabs-indicator': {
        transition: 'none',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        width: 'calc(100% -40px)',
        bottom: theme => `${1 + parseFloat(theme.spacing(4))}px`,
        '& > div': {
          backgroundImage: getGradient(first, last),
          height: theme => `${3 + parseFloat(theme.spacing(4))}px`,
          width: '100%'
        }
      }
    }}
  />
);

export default ProcessPathTabs;
